
import axios from "axios";

export const getInstance = () => {
    let headers = {
        "Content-Type": "application/json",
    } as any;

    if (localStorage.getItem("token") !== null) {
        headers["Authorization"] = "Bearer " + localStorage.getItem("token");
    }

    const instance = axios.create({
        validateStatus: function (status) {
            return true;
        },
        headers: headers
    });
    return instance;
}

